/**
 * @generated SignedSource<<7139f6a29e89be19a9430eed47078ff6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersAppBarVariantBase$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsLiveArticle" | "helpersCheckIsPlusPage" | "helpersCheckIsPostMagazineArticle" | "helpersCheckIsPostiesArticle" | "helpersCheckIsPostiesPage" | "helpersCheckIsSeriesArticle" | "helpersCheckIsStyleArticle" | "helpersSectionContent" | "helpersStyleSectionContent">;
  readonly " $fragmentType": "helpersAppBarVariantBase";
};
export type helpersAppBarVariantBase$key = {
  readonly " $data"?: helpersAppBarVariantBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarVariantBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersAppBarVariantBase"
};

(node as any).hash = "51a724cb4ea15b0ed4e2fad3d9031af5";

export default node;
